import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i PDF. Accesso immediato, nessuna attesa. Puoi usarli già dalla prossima lezione.'
}, {
  q: 'Serve per docenti alle prime armi?',
  a: 'Assolutamente sì. Il sistema funziona sia per chi inizia sia per docenti esperti che vogliono una struttura professionale. Il Tomo 1 parte da zero, nessuna conoscenza pregressa richiesta.'
}, {
  q: 'Cosa succede se ho studenti di livelli diversi?',
  a: 'Il Kit è pensato esattamente per questo. Ogni tomo ha esercizi su 4 livelli di difficoltà e il Bonus 1 include strategie specifiche per BES, DSA e plusdotati.'
}, {
  q: 'Il Kit è allineato ai programmi MIUR?',
  a: 'Sì. Tutti i contenuti sono sviluppati in coerenza con le Indicazioni Nazionali per gli Istituti Tecnici e Professionali e con il framework DigComp 2.2.'
}, {
  q: 'Per quanto tempo ho accesso ai materiali?',
  a: 'A vita. Paghi una volta sola e i materiali sono tuoi per sempre, inclusi tutti gli aggiornamenti futuri.'
}, {
  q: 'Posso usare il materiale sia in aula che in laboratorio?',
  a: "Certamente. Il Kit include sia attività 'unplugged' (senza computer) perfette per l'aula, sia progetti pratici e codice skeleton ideali per le ore di laboratorio pratico."
}, {
  q: 'In che formato sono i file?',
  a: 'Tutti i materiali sono forniti in formato PDF ad alta risoluzione, ottimizzati sia per la stampa che per la visualizzazione su tablet, smartphone o LIM.'
}, {
  q: 'Posso condividere il materiale con i miei colleghi?',
  a: "La licenza è individuale per singolo docente. Se il tuo dipartimento desidera adottare il Kit per più docenti, contattaci per una licenza d'istituto."
}, {
  q: 'È possibile richiedere fattura per la scuola o usare la Carta del Docente?',
  a: "Al momento l'acquisto a questo prezzo promozionale è riservato ai privati con ricevuta standard. Stiamo lavorando per integrare la Carta del Docente in futuro."
}, {
  q: 'Offrite supporto se ho dubbi su un progetto?',
  a: "Sì, il Kit include le soluzioni complete per il docente (Bonus 4), ma se hai dubbi specifici puoi sempre scriverci all'email di supporto dedicata."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-12 uppercase text-brand-cream" data-id="element-81">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-84">
                <span className="font-bold text-brand-cream pr-4" data-id="element-85">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>

              <AnimatePresence data-id="element-87">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 pt-0 text-gray-400 font-medium leading-relaxed" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}